/**
 * Implementation of Widget Card component
 *
 * @author - Harsh Tomar
 */

// Dependencies
import React, { ReactElement } from "react";

type Props = {
  name: string;
  description: string;
  icon: ReactElement;
  color: string;
};

export default function WidgetCard(props: Props) {
  return (
    <div className="h-32 transition-all relative overflow-hidden p-4 rounded-xl cursor-pointer bg-white">
      <div
        className="absolute w-full h-full rounded-full left-2/3 opacity-20"
        style={{ backgroundColor: props.color }}
      ></div>
      {React.cloneElement(props.icon, {
        className:
          "text-white absolute right-5 top-1/2 transform -translate-y-1/2",
        size: 48,
        color: props.color,
      })}

      <p className="text-black w-2/3">{props.description}</p>
      <h1 className="text-2xl mt-6 font-semibold text-black">{props.name}</h1>

    </div>
  );
}
